import { render, staticRenderFns } from "./CollectionLogDetail.vue?vue&type=template&id=1fe8f9ed&scoped=true"
import script from "./CollectionLogDetail.vue?vue&type=script&lang=js"
export * from "./CollectionLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe8f9ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe8f9ed')) {
      api.createRecord('1fe8f9ed', component.options)
    } else {
      api.reload('1fe8f9ed', component.options)
    }
    module.hot.accept("./CollectionLogDetail.vue?vue&type=template&id=1fe8f9ed&scoped=true", function () {
      api.rerender('1fe8f9ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationRecord/collectionLog/CollectionLogDetail.vue"
export default component.exports